import React from 'react'
const VELKI_APP_NAME="VELLKI";
// const VELKI_API_URL="http://localhost/agent";
const VELKI_API_URL="https://vellkiagentlist.live";
const VELKI_API_KEY = "123";

const VELKI_HOME_URL="https://vellkiagentlist.live";
export default VELKI_APP_NAME;
export {VELKI_API_URL,VELKI_API_KEY,VELKI_HOME_URL};